import FieldNumberOutlined from '@ant-design/icons/lib/icons/FieldNumberOutlined';
import App from 'antd/lib/app';
import Empty from 'antd/lib/empty';
import Row from 'antd/lib/row';
import Skeleton from 'antd/lib/skeleton';
import React from 'react';
import { InformationCard } from '../../../../components/informationCard/informationCard';
import { InformationCardTitle } from '../../../../components/informationCard/informationCardTitle';
import { MetricData } from '../../../../components/metricData/metricData';
import { numberFormatter } from '../../../../domain/common/numberFormatter';
import { IFetchEventMetricsRequestParams } from '../../../../domain/event/interface';
import { useEventMetricsQuery } from '../../../../domain/event/queries';
import './EventsMetrics.css';

interface IEventMetricsProps {
    filter: IFetchEventMetricsRequestParams;
}

export const EventsMetrics: React.FC<IEventMetricsProps> = ({ filter }) => {
    const { notification } = App.useApp();

    const { data: metricsData, isLoading, isError, error } = useEventMetricsQuery(filter);

    if (isError) {
        notification.error({
            key: 'fetch-events-metrics-error',
            message: error.message || 'Cannot fetch event metrics data!',
        });
    }

    if (isLoading) {
        return <Skeleton loading={isLoading} paragraph active />;
    }

    if (!metricsData) {
        return (
            <Row justify="center">
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </Row>
        );
    }

    return (
        <div className="events-metrics">
            <Row gutter={[16, 16]} align="middle" justify="center">
                <InformationCard
                    classNames={['metric-information-card']}
                    title={<InformationCardTitle title="of Event Days" icon={<FieldNumberOutlined style={{ fontSize: '16px' }} />} />}
                >
                    <MetricData value={metricsData.days} />
                </InformationCard>
                <InformationCard
                    classNames={['metric-information-card']}
                    title={<InformationCardTitle title="States with Events" icon={<FieldNumberOutlined style={{ fontSize: '16px' }} />} />}
                >
                    <MetricData value={numberFormatter.format(metricsData.locations)} />
                </InformationCard>
                <InformationCard
                    classNames={['metric-information-card']}
                    title={<InformationCardTitle title="Total Site Events" icon={<FieldNumberOutlined style={{ fontSize: '16px' }} />} />}
                >
                    <MetricData value={numberFormatter.format(metricsData.eventsCount)} />
                </InformationCard>
            </Row>
        </div>
    );
};
